/**
 * 
 * @param {any} res organization details 
 * @returns if the org has atleast one inward bank as partner
 */

export const hasInwardBankMethod = (res) => {

    if(res.inwardYes ||
       res.inwardIDFC ||
       res.inwardRBL || 
        res.inwardSBM
    ) return true;

    return false;
}